import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IClinicTamsFilterResponse, IClinicTamsFilterResponseData } from "@/api_framework/api_modals/Inventory";

AxiosCurlirize(axios, () => {});
export const useClinicTamsFilterAPI = () => {
  const [clinicList, setClinicList] = useState<IClinicTamsFilterResponseData[]>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (cityId?: string, type?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params: Record<string, string> = {};
        if (cityId) {
          params["city_id"] = cityId;
        }
        if (type) {
          params["warehouse_type"] = type.toUpperCase();
        }
        await axios
          .get(INVENTORY_MODULE?.CLINIC_TAMS_FILTER_API?.baseURL ?? "", {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IClinicTamsFilterResponse>) => {
            if (res.data.status === true) {
              setClinicList(res.data.data);
            } else {
              setClinicList(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setClinicList(null);
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, clinicList };
};
